import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Input,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  CardBody,
  ModalFooter,
  Card,
  CustomInput,
  Collapse,
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import Select from 'react-select';
import { injectIntl } from 'react-intl';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
import { connect } from 'react-redux';
import {
  API_Documents,
  postAPI_Create_QuestionSet,
  putAPI_Update_QuestionSet,
  API_OpenAI_Assistant,
  API_Publish_Assistant,
  gAPI_DynmicApisList,
} from '../../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import IntlMessages from '../../../../../../helpers/IntlMessages';
import Validation from '../../../../../../components/Validation';
import moment from 'moment';
import CustomSelectInput from '../../../../../../components/common/CustomSelectInput';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import UploadJson from '../../json';
import { NotificationManager } from '../../../../../../components/common/react-notifications';
import Logs from './Logs';
import json from '../../json';
import "../../../../../../assets/QuestionSet.css";
const fromPropertyId = process.env.REACT_APP_COPILOT_PROPERTY_ID;
const fromGroupId = process.env.REACT_APP_COPILOT_GROUP_ID;

function QuestionSetForm({
  /** Globle property id from redux */
  propertyId,
  CancelQuestionSet,
  loadResponse,
  setName,
  setId,
  updateSet,
  type,
  setDescription,
  setInstructions,
  locale,
  aiModel,
  aiAssistantId,
  userName,
  actions,
  seriesFlowInvokeApi,
  seriesTrainingData,
  seriesConversationFlow,
  setIsGroupVisible,
  dynmaicQuestionSet,
  aiReasoningEfforts,
  aiVerbosity,
  isSuperAdmin,
}) {

  const [showLogs, setShowLogs] = useState(false);
  const [imageIndex, setImageIndex] = useState(-1);
  const [jsonVisible, setjsonVisible] = useState(false);
  const [documentList, setDocumentList] = useState([]);
  const [selectedDocumentList, setSelectedDocumentList] = useState([]);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [visible, setVisible] = useState(false);
  const [editJson, setEditJson] = useState(false);
  const [currentJson, setCurrentJson] = useState('');
  const [isEditingTitle, setIsEditingTitle] = useState(false);
  const [buttonTextInput, setButtonTextInput] = useState(
    setName == undefined ? '' : setName
  );
  const [openInstruction, setOpenInstruction] = useState('');
  const [pubishConversation, setPublishConversation] = useState(
    seriesConversationFlow || false
  );
  const [seriesType, setSeriesType] = useState(
    type == undefined ? 'ConversationFlow' : type
  );
  const [seriesDescription, setSeriesDescription] = useState(
    setDescription == undefined ? '' : setDescription
  );
  const [seriresInstruction, setSeriresInstructions] = useState(
    setInstructions == undefined ? '' : setInstructions
  );
  const [systemRules, setSystemRules] = useState('');
  const [conversationHandling, setConversationHandling] = useState('');

  const [openAiModel, setOpenAiModel] = useState(
    aiModel !== undefined && aiModel !== null ? aiModel : ''
  );
  const [openAiAssistantId, setOpenAiAssistantId] = useState(
    aiAssistantId !== undefined && aiAssistantId !== null && aiAssistantId
  );
  const [seriesIsGroupVisible, setSeriesIsGroupVisible] = useState(
    setIsGroupVisible == undefined ? false : setIsGroupVisible
  );
  // const [openAiReasoningEfforts, setOpenAiReasoningEfforts] = useState(
  //   aiReasoningEfforts !== undefined && aiReasoningEfforts !== null ? aiReasoningEfforts : 'minimal'
  // );
  const [openAiReasoningEfforts, setOpenAiReasoningEfforts] = useState('minimal');
  const [openAiVerbosity, setOpenAiVerbosity] = useState(
    aiVerbosity !== undefined && aiVerbosity !== null ? aiVerbosity : 'medium'
  );
  const [flowTrainingData, setFlowTrainingData] = useState(
    seriesTrainingData || {
      isEnabled: false,
      includeDocuments: false,
      includeFAQ: false,
      includeKnowledgeData: false,
      documents: [],
    }
  );
  const [tonePersonality, setTonePersonality] = useState('');
  const [flowInvokeApi, setFlowInvokeApi] = useState(
    seriesFlowInvokeApi || {
      isEnabled: true,
      json: [],
      items: [],
    }
  );

  const [postData, setPostData] = useState({
    GroupId: getGroupID(),
    PropertyId: propertyId === '-1' ? null : propertyId,
    Name: '',
    Description: '',
    IsGroupVisible: false,
    Status: 'Active',
    Creator: userName,
    Type: 'ConversationFlow',
    languageCode: locale,
  });
  const [browseApiId, setBrowseApiId] = useState('');
  const [isbrowseApi, setIsbrowseApi] = useState(false);
  const [templateApiList, setTemplateApiList] = useState([]);

  const handleToggleLogs = () => setShowLogs(!showLogs);

  const toggle = () => {
    setVisible(!visible);
  };

  const toggleJson = () => {
    setEditJson(!editJson);
  };

  const toggleJsonUploader = (index) => {
    setImageIndex(index);
    setjsonVisible(!jsonVisible);
  };
  const toggleInstruction = (key) => {
    setOpenInstruction(prev => (prev === key ? '' : key));
  };
  const getApiMeta = (jsonString) => {
    try {
      const parsed = JSON.parse(jsonString);

      const matched = templateApiList.find(t => {
        try {
          const templateParsed = JSON.parse(t.apiCode);
          return templateParsed.name === parsed.name;
        } catch {
          return false;
        }
      });

      if (matched) {
        return {
          name: matched.apiName,
          description: matched.description,
        };
      }

      return {
        name: parsed.name || "Custom Action",
        description: parsed.description || "",
      };

    } catch {
      return {
        name: "Invalid JSON",
        description: "",
      };
    }
  };
  console.log('12', dynmaicQuestionSet)
  useEffect(() => {
    if (dynmaicQuestionSet) {
      setButtonTextInput(dynmaicQuestionSet.name);
      setSeriesType(dynmaicQuestionSet.type);
      setSeriresInstructions(dynmaicQuestionSet?.instructions || '');

      setTonePersonality(
        dynmaicQuestionSet.assistantInstructions?.tonePersonality || ''
      );
      setSystemRules(
        dynmaicQuestionSet.assistantInstructions?.systemRules || ''
      );
      setConversationHandling(
        dynmaicQuestionSet.assistantInstructions?.conversationHandling || ''
      );

      setSeriesIsGroupVisible(dynmaicQuestionSet.isGroupVisible);
      setOpenAiModel(dynmaicQuestionSet.openAiModel);
      setOpenAiVerbosity(dynmaicQuestionSet.openAiVerbosity);
      setFlowTrainingData(dynmaicQuestionSet.flowTrainingData);

      const oldJson = dynmaicQuestionSet.flowInvokeApi?.json || [];
      const oldItems = dynmaicQuestionSet.flowInvokeApi?.items || [];

      const mappedItems =
        oldItems && oldItems.length > 0
          ? oldItems.map(i => ({
            json: i.json,
            instructions: i.instructions || ''
          }))
          : oldJson.map(j => ({
            json: j,
            instructions: ''
          }));

      setFlowInvokeApi({
        isEnabled: dynmaicQuestionSet.flowInvokeApi?.isEnabled || true,
        items: mappedItems,
      });
    }
  }, [dynmaicQuestionSet]);

  const selectedJson = (image) => {
    const newItems = [...(flowInvokeApi.items || [])];

    newItems.push({
      json: image.status,
      instructions: ''
    });

    setFlowInvokeApi({
      ...flowInvokeApi,
      items: newItems,
    });

    toggleJsonUploader();
  };
  const formatJson = (value) => {
    try {
      return JSON.stringify(JSON.parse(value), null, 2);
    } catch {
      return value;
    }
  };
  const JsonUploaderButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal
                isOpen={jsonVisible}
                toggle={toggleJsonUploader}
              >
                <ModalHeader toggle={toggleJsonUploader}>
                  Upload New Json
                </ModalHeader>
                <ModalBody>
                  <UploadJson
                    selectedJson={selectedJson}
                    togglegallery={toggleJsonUploader}
                    hideUserUploads={false}
                    searchText={''}
                  />
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  const deleteJson = (index) => {
    const updated = [...(flowInvokeApi.items || [])];
    updated.splice(index, 1);

    setFlowInvokeApi({
      ...flowInvokeApi,
      items: updated,
    });
  };


  const handleAddApiJson = () => {
    const updated = [...(flowInvokeApi.items || [])];

    updated.push({
      json: '',
      instructions: ''
    });

    setFlowInvokeApi({
      ...flowInvokeApi,
      items: updated,
    });

    setCurrentJson({
      text: '',
      id: updated.length - 1,
    });

    toggleJson();
  };

  useEffect(() => {
    AxiosAPI({
      method: 'get',
      url: `${API_Documents}?groupId=${getGroupID()}&propertyId=${propertyId}&sortType=`,
    }).then((res) => {
      if (res.data !== undefined && res.data.length > 0) {
        let lst = [];
        res.data.map((m) => lst.push({ id: m.id, name: m.title }));
        let selectedList = [];
        if (
          flowTrainingData.documents !== undefined &&
          flowTrainingData.documents !== null &&
          flowTrainingData.documents.length > 0
        ) {
          flowTrainingData.documents.map((m) => {
            if (res.data.filter((f) => f.id === m).length > 0)
              selectedList.push({
                key: res.data.filter((f) => f.id === m)[0].id,
                label: res.data.filter((f) => f.id === m)[0].title,
                value: res.data.filter((f) => f.id === m)[0].id,
              });
          });
        }
        setDocumentList(lst);
        setSelectedDocumentList(selectedList);
      }
    });
  }, [propertyId]);

  useEffect(() => {
    setPostData(prev => ({
      ...prev,
      Name: buttonTextInput,
      Type: seriesType,
      Description: seriesDescription,
      IsGroupVisible: seriesIsGroupVisible,
      OpenAiModel: openAiModel,
      OpenAiReasoningEfforts: 'minimal',
      OpenAiVerbosity: openAiVerbosity,
      Instructions: seriresInstruction,
      AssistantInstructions: {
        SystemMessage: seriresInstruction,
        TonePersonality: tonePersonality,
        SystemRules: systemRules,
        ConversationHandling: conversationHandling,
      },
      FlowTrainingData: flowTrainingData,
      FlowInvokeApi: flowInvokeApi,
      pubishConversationFlow: pubishConversation,
    }));
  }, [
    buttonTextInput,
    seriesType,
    seriesDescription,
    openAiModel,
    seriresInstruction,
    tonePersonality,
    systemRules,
    conversationHandling,
    flowTrainingData,
    flowInvokeApi,
    pubishConversation,
    openAiVerbosity
  ]);
  console.log("1111", flowInvokeApi)
  const handleTrainingData = (e) => {
    console.log(e.target.name, e.target.checked);
    setFlowTrainingData({
      ...flowTrainingData,
      [e.target.name]: e.target.checked,
    });
  };

  const handlePublishConversation = (e) => {
    setPublishConversation(e.target.checked);
  };
  const handleInvokeApiFlow = (value, index) => {

    const updated = [...(flowInvokeApi.items || [])];

    updated[index] = {
      ...updated[index],
      json: value
    };

    setFlowInvokeApi({
      ...flowInvokeApi,
      items: updated,
    });

    setCurrentJson({
      text: value,
      id: index
    });
  };


  const handleDocuments = (options) => {
    setSelectedDocumentList(options);
    if (options.filter((f) => f.value === 'All').length === 0) {
      setFlowTrainingData({
        ...flowTrainingData,
        documents: options.map((i) => i.value),
      });
    } else {
      setFlowTrainingData({
        ...flowTrainingData,
        documents: options.filter((f) => f.id !== 'All').map((i) => i.id),
      });
    }
  };
  const handleCaptionChange = (e) => {
    setButtonTextInput(e.target.value);
  };
  const handleOpenAiModel = (e) => {
    setOpenAiModel(e.target.value);
  };
  // const handleOpenAiReasoningEfforts = (value) => {
  //   setOpenAiReasoningEfforts(value);
  // };

  const handleOpenAiVerbosity = (value) => {
    setOpenAiVerbosity(value);
  };
  const handleTypeChange = (e) => {
    setSeriesType(e.target.value);
  };
  const handleDescriptionChange = (e) => {
    setSeriesDescription(e.target.value);
  };
  const handleCheckChange = (e) => {
    setSeriesIsGroupVisible(e.target.checked);
  };

  const handlePublish = () => {
    NotificationManager.success(
      '',
      'We are processing your request. The changes are Live in under a minute',
      3000,
      null,
      null,
      'success'
    );
    AxiosAPI({
      method: 'post',
      url: `${API_Publish_Assistant}`,
      data: { id: setId },
    }).then((res) => {
      try {

        let functions = [];

        if (flowInvokeApi && flowInvokeApi.isEnabled === true) {

          if (flowInvokeApi.items && flowInvokeApi.items.length > 0) {

            flowInvokeApi.items.forEach(item => {
              if (item.json && item.json.trim() !== '') {
                try {
                  const parsed = JSON.parse(item.json);

                  functions.push({
                    ...parsed,
                    internalInstructions: item.instructions || ''
                  });

                } catch (e) {
                  console.error("Invalid JSON:", item.json);
                }
              }
            });

          }

          // 🧓 BACKWARD COMPATIBILITY
          else if (flowInvokeApi.json && flowInvokeApi.json.length > 0) {

            flowInvokeApi.json.forEach(m => {
              if (m && m.trim() !== '') {
                try {
                  functions.push(JSON.parse(m));
                } catch (e) {
                  console.error("Invalid JSON:", m);
                }
              }
            });

          }
        }

        let body = {
          instructions: seriresInstruction,
          model: openAiModel,
          name: buttonTextInput,
          id: setId,
          function: functions,
          vector_id: res.data.status ?? '',
          content: {
            instructions: setInstructions,
            model: aiModel,
            name: setName,
            flowInvokeApi: flowInvokeApi,
            flowTrainingData: flowTrainingData,
          },
          action:
            'Last Published By ' + userName + ' at ' + moment().format('LLL'),
        };
        if (
          res.data.status !== undefined &&
          res.data.status !== null &&
          res.data.status !== ''
        )
          body.vector_id = res.data.status !== null && res.data.status;
        if (
          openAiAssistantId !== undefined &&
          openAiAssistantId !== null &&
          openAiAssistantId !== ''
        ) {
          AxiosAPI({
            method: 'put',
            url: `${API_OpenAI_Assistant}/update/${openAiAssistantId}`,
            data: body,
          }).then((res) => {
            CancelQuestionSet();
            loadResponse();
          });
        } else {
          AxiosAPI({
            method: 'post',
            url: `${API_OpenAI_Assistant}/create`,
            data: body,
          }).then((res) => {
            CancelQuestionSet();
            loadResponse();
          });
        }
      } catch (error) {
        console.error(error);
      }
    });
  };

  const handleInstructionChange = (e) => {
    setSeriresInstructions(e.target.value);
  };

  const handleSave = async () => {
    postData.OpenAiReasoningEfforts = 'minimal';
    postData.IsGroupVisible = seriesIsGroupVisible;
    console.log('29008', postData, setId)
    if (setId === undefined) {
      try {
        return await AxiosAPI({
          method: 'post',
          url: `${postAPI_Create_QuestionSet}`,
          data: postData,
        }).then((res) => {
          if (
            res.data.HttpStatusCode !== undefined &&
            res.data.HttpStatusCode === 400 &&
            res.data.Messages !== undefined &&
            res.data.Messages !== null &&
            res.data.Messages.length > 0
          ) {
            setMsg(res.data.Messages);
            setOpen(true);
          } else {
            setTimeout(() => {
              CancelQuestionSet();
              loadResponse();
            }, 1000);
          }
        });
      } catch (error) {
        console.error(error);
      }
    } else {
      let data = {
        Name: buttonTextInput,
        Type: seriesType,
        Instructions: seriresInstruction,
        AssistantInstructions: {
          SystemMessage: seriresInstruction,
          TonePersonality: tonePersonality,
          SystemRules: systemRules,
          ConversationHandling: conversationHandling,
        },
        Description: seriesDescription,
        IsGroupVisible: seriesIsGroupVisible,
        flowTrainingData: flowTrainingData,
        flowInvokeApi: flowInvokeApi,
        Status: 'Active',
        Updater: 'Dashboard',
        Creator: userName,
        publishConversationFlow: pubishConversation,
        OpenAiModel: openAiModel,
        OpenAiReasoningEfforts: 'minimal',
        OpenAiVerbosity: openAiVerbosity,
      };
      try {
        return await AxiosAPI({
          method: 'put',
          url: `${putAPI_Update_QuestionSet}/${setId}`,
          data: data,
        }).then((res) => {
          if (
            res.data.HttpStatusCode !== undefined &&
            res.data.HttpStatusCode === 400 &&
            res.data.Messages !== undefined &&
            res.data.Messages !== null &&
            res.data.Messages.length > 0
          ) {
            setMsg(res.data.Messages);
            setOpen(true);
          } else {
            updateSet(res.data);
            NotificationManager.success(
              'Conversation Flow updated successfully',
              'Success',
              3000
            );
          }
        });
      } catch (error) {
        console.error(error);
      }
    }
  };
  const isValidJson = (value) => {
    try {
      JSON.parse(value);
      return true;
    } catch {
      return false;
    }
  };
  const isPrebuiltApi = (jsonString) => {
    try {
      const parsed = JSON.parse(jsonString);

      return templateApiList.some(t => {
        const templateParsed = JSON.parse(t.apiCode);
        return templateParsed.name === parsed.name;
      });

    } catch {
      return false;
    }
  };
  const addCurrentJson = (val, index) => {
    setCurrentJson({
      text: formatJson(val || ''),
      id: index,
    });

    toggleJson();
  };
  const handleApiSwitch = (value) => {
    setFlowInvokeApi({ ...flowInvokeApi, isEnabled: value });
  };

  const handleTrainingSwitch = (value) => {
    setFlowTrainingData({ ...flowTrainingData, isEnabled: value });
  };

  const LoadBrowseApiList = async () => {
    return await AxiosAPI({
      methed: 'get',
      url: `${gAPI_DynmicApisList}/?propertyId=${fromPropertyId}&groupId=${fromGroupId}`,
    }).then((res) => {
      setTemplateApiList(res.data);
    });
  };
  const handleCancel = () => {
    CancelQuestionSet();
  };

  const checkedFlow = (e) => {
    if (e.target.checked) {
      setBrowseApiId(e.target.value);
    }
    if (!e.target.checked) {
      setBrowseApiId('');
    }
  };
  const toggleBrowswApi = () => {
    setIsbrowseApi(true);

    if (templateApiList.length === 0) {
      LoadBrowseApiList();
    }
  };

  const AddBrowseAPI = () => {
    var data = templateApiList.filter((l) => l.id == browseApiId);
    if (data.length > 0) {
      var flowlist = [...(flowInvokeApi.items || [])];
      flowlist.push({
        json: data[0].apiCode,
        instructions: data[0].instructions || data[0].Instructions || ''
      });

      setFlowInvokeApi({
        ...flowInvokeApi,
        items: flowlist,
      });

      setIsbrowseApi(false);

    }
  };
  useEffect(() => {
    LoadBrowseApiList();
  }, []);
  const isJsonObject = (value) => {
    try {
      JSON.parse(value);
      return true;
    } catch {
      return false;
    }
  };
  return (
    <div className="question-set-form">
      <Row>

        {setId === undefined && (
          <Colxx xxs="12" className="mb-3">
            <Label>Flow Type</Label>
            <Input className='input_sty'
              type="select"
              value={seriesType}
              name="type"
              onChange={handleTypeChange}
            >
              {/* <option value="Products">Products</option>
              <option value="Rooms">Rooms</option>
              <option value="Addons">Addons</option>
              <option value="Promos">Promos</option>
              <option value="Property">Property</option> */}
              <option value="ConversationFlow">Static Conversation Flow</option>
              <option value="DynamicConversationFlow">
                Dynamic Conversation Flow
              </option>
            </Input>
          </Colxx>
        )}
        {seriesType === 'ConversationFlow' && (
          <Colxx xxs="12" className="mb-3">
            <Label>    <IntlMessages id='pages.description' /></Label>
            <Input className='input_sty'
              type="textarea"
              value={seriesDescription}
              onChange={handleDescriptionChange}
              placeholder="Enter the short description"
            ></Input>
          </Colxx>
        )}
        {seriesType === 'DynamicConversationFlow' && (
          <Colxx xxs="12">
            <Card className="assistant-card">
              <CardBody className="assistant-body">
                <div className="section-title">
                  Assistant Instructions
                </div>



                <div style={{ marginBottom: '4px' }}>
                  <div
                    className="d-flex justify-content-between align-items-center cursor-pointer"
                    style={{ cursor: 'pointer' }}
                    onClick={() => toggleInstruction('taskOverview')}
                  >
                    <div>
                      <span className="instruction-title">
                        Task Overview
                      </span>
                      <span
                        className='prebuilt-desc-inline'
                      >
                        —  A single line purpose and scope
                      </span>
                    </div>
                    <span className="instruction-arrow">{openInstruction === 'taskOverview' ? '▾' : '▸'}</span>
                  </div>
                  <Collapse isOpen={openInstruction === 'taskOverview'}>
                    <Input
                      className="input_sty mt-2"
                      style={{ height: '150px', fontSize: '14px' }}
                      type="textarea"
                      value={seriresInstruction || ''}
                      placeholder="What is the assistant supposed to do?"
                      onChange={(e) => setSeriresInstructions(e.target.value)}
                    />
                  </Collapse>
                </div>
                <div>
                  <div
                    className="d-flex justify-content-between align-items-center"
                    onClick={() => toggleInstruction('conversationHandling')}
                    style={{ cursor: 'pointer' }}
                  >
                    <div>
                      <span className="instruction-title">Conversation Handling</span>
                      <span
                        className='prebuilt-desc-inline'
                      >
                        —  Behavior, workflows & query handling
                      </span>
                    </div>
                    <span className="instruction-arrow">
                      {openInstruction === 'conversationHandling' ? '▾' : '▸'}
                    </span>
                  </div>
                  <Collapse isOpen={openInstruction === 'conversationHandling'}>
                    <Input
                      className="input_sty"
                      style={{ height: '150px' }}
                      type="textarea"
                      value={conversationHandling}
                      placeholder='How should the assistant handle conversations and user questions?'
                      onChange={(e) => setConversationHandling(e.target.value)}
                    />
                  </Collapse>
                </div>

                <div>
                  <div
                    className="d-flex justify-content-between align-items-center"
                    onClick={() => toggleInstruction('tonePersonality')}
                    style={{ cursor: 'pointer' }}
                  >
                    <div>
                      <span className="instruction-title">Conversation Style and Personality</span>

                      <span
                        className='prebuilt-desc-inline'
                      >
                        —  Tone, personality, and responsibilities
                      </span>
                    </div>
                    <span className="instruction-arrow">
                      {openInstruction === 'tonePersonality' ? '▾' : '▸'}
                    </span>
                  </div>
                  <Collapse isOpen={openInstruction === 'tonePersonality'}>
                    <Input
                      className="input_sty"
                      style={{ height: '150px' }}
                      type="textarea"
                      value={tonePersonality}
                      placeholder='How should the assistant sound and behave while interacting with users?'
                      onChange={(e) => setTonePersonality(e.target.value)}
                    />
                  </Collapse>
                </div>
                {isSuperAdmin && isSuperAdmin === true &&
                  <div>
                    <div
                      className="d-flex justify-content-between align-items-center cursor-pointer"
                      style={{ cursor: 'pointer' }}
                      onClick={() => toggleInstruction('systemRules')}
                    >
                      <div>
                        <span className="instruction-title">
                          Safety & System Rules
                        </span>
                        <span
                          className='prebuilt-desc-inline'
                        >
                          —  Define constraints, safety, compliance rules, and actions the assistant must never perform
                        </span>
                      </div>
                      <span className="instruction-arrow warning">{openInstruction === 'systemRules' ? '▾' : '▸'}</span>
                    </div>
                    <Collapse isOpen={openInstruction === 'systemRules'}>
                      <Input
                        className="input_sty mt-2"
                        style={{ height: '150px', fontSize: '14px' }}
                        type="textarea"
                        value={systemRules || ''}
                        placeholder="Safety rules, constraints, and forbidden actions."
                        onChange={(e) => setSystemRules(e.target.value)}
                      />
                    </Collapse>
                  </div>
                }
              </CardBody>
            </Card>
          </Colxx>
        )}

        {isSuperAdmin && isSuperAdmin === true && seriesType === 'DynamicConversationFlow' && (
          <Colxx xxs="12" className="mb-3">
            <Label>AI Model<span style={{ color: 'grey', fontSize: '12px', paddingLeft: '6px' }} > (Only visible to Super Admins)</span></Label>
            <Input className='input_sty'
              type="select"
              value={openAiModel}
              name="type"
              onChange={handleOpenAiModel}
            >
              <option value="">Choose AI Model</option>
              <option value="gpt-3.5-turbo">GPT 3.5 Turbo</option>
              <option value="gpt-4o">GPT 4o</option>
              <option value="gpt-4o-mini">GPT 4o Mini</option>
              <option value="gpt-5-mini">GPT 5 Mini</option>
              <option value="AzureGpt4">Azure Open AI (Beta)</option>
            </Input>
          </Colxx>
        )}
        {seriesType === 'DynamicConversationFlow' && openAiModel === 'gpt-5-mini' &&
          <Fragment>
            {/* <Colxx xxs="12" className="mb-3">
              <h7>Reasoning Efforts</h7>
              <Input
                type="select"
                name="reasoningEfforts"
                value={openAiReasoningEfforts}
                onChange={(e) => handleOpenAiReasoningEfforts(e.target.value)}
                className="mt-1"
              >
                <option value="">Select</option>
                <option value="minimal">Minimal</option>
                <option value="low">Low</option>
                <option value="medium">Medium</option>
                <option value="high">High</option>
              </Input>
            </Colxx> */}
            <Colxx xxs="12" className="mb-2">
              <h7>Verbosity</h7>
              <Input className='input_sty mt-1'
                type="select"
                name="verbosity"
                value={openAiVerbosity}
                onChange={(e) => handleOpenAiVerbosity(e.target.value)}
              >
                <option value="">Select</option>
                <option value="low">Low</option>
                <option value="medium">Medium</option>
                <option value="high">High</option>
              </Input>
            </Colxx>
          </Fragment>
        }
        {seriesType === 'DynamicConversationFlow' && (
          <>
            {isSuperAdmin && isSuperAdmin === true &&
              <Colxx xxs="12">
                <Card className="mb-2">
                  <CardBody>
                    <h6>Include Knowledge<span style={{
                      color: 'grey', fontSize: '12px', paddingLeft: '6px'
                    }} >(Only visible to Super Admins)</span></h6>
                    < div className="d-flex align-items-center mt-2" >
                      <Switch
                        checked={flowTrainingData.isEnabled}
                        onChange={handleTrainingSwitch}
                      />
                      <span className="ml-2">
                        Include documents, FAQs, and other knowledge you have added in the Knowledge Hub.
                      </span>
                    </div>
                  </CardBody>
                </Card>
              </Colxx>
            }
            <Colxx xxs="12">
              <Card className="mb-2">
                <CardBody>
                  <h6>Pre-Built Blocks</h6>
                  <p className="text-muted small mb-2">
                    Add ready-made behaviors and actions to quickly customize your assistant
                  </p>

                  {(flowInvokeApi.items || []).map((item, index) => {
                    if (!(isValidJson(item.json) && isPrebuiltApi(item.json))) {
                      return null;
                    }

                    const meta = getApiMeta(item.json);

                    return (
                      <div key={index} className="api-row">
                        <div className="api-left">
                          <div className="prebuilt-inline">
                            <span className="prebuilt-title">{meta.name}</span>
                            {meta.description && (
                              <span className="prebuilt-desc-inline">
                                — {meta.description}
                              </span>
                            )}
                          </div>

                        </div>

                        <div className="api-actions">
                          <FontAwesomeIcon
                            icon={faEdit}
                            onClick={() => addCurrentJson(item.json, index)}
                          />
                          <FontAwesomeIcon
                            icon={faTrashAlt}
                            onClick={() => deleteJson(index)}
                          />
                        </div>
                      </div>
                    );
                  })}


                  <Button
                    size="sm"
                    color="primary"
                    outline
                    onClick={toggleBrowswApi}
                  >
                    + Browse Library
                  </Button>
                </CardBody>
              </Card>
            </Colxx>
            {isSuperAdmin && isSuperAdmin === true &&
              <Colxx xxs="12">
                <Card className="mb-3">
                  <CardBody>
                    <h6>Custom Actions (Advanced) <span style={{
                      color: 'grey', fontSize: '12px', paddingLeft: '6px'
                    }} >(Only visible to Super Admins)</span></h6>
                    < p className="text-muted small" >
                      Connect your own APIs so the assistant can take actions using your systems and data.
                      This is for advanced users who want deeper integrations.
                    </p>

                    {(flowInvokeApi.items || []).map((item, index) => {
                      const isPrebuilt =
                        isValidJson(item.json) && isPrebuiltApi(item.json);

                      if (isPrebuilt) return null;

                      return (
                        <div key={index} className="api-row">
                          <div className="api-left">
                            <Input
                              value={item.json || ''}
                              disabled
                              className="custom-json-input"
                            />
                          </div>

                          <div className="api-actions">
                            <FontAwesomeIcon
                              icon={faEdit}
                              onClick={() => addCurrentJson(item.json, index)}
                            />
                            <FontAwesomeIcon
                              icon={faTrashAlt}
                              onClick={() => deleteJson(index)}
                            />
                          </div>
                        </div>

                      );
                    })}


                    <Button
                      size="sm"
                      outline
                      color="primary"
                      onClick={handleAddApiJson}
                    >
                      + Add Action
                    </Button>
                  </CardBody>
                </Card>
              </Colxx>
            }
          </>
        )}
        {seriesType === 'ConversationFlow' && (
          <>
            <Colxx sm={12} className="mb-3">
              <CustomInput
                type="checkbox"
                name="publishConversation"
                id="publishConversation"
                checked={pubishConversation}
                onChange={(e) => handlePublishConversation(e)}
                label={`Include this flow for auto-triggering if there is a strong match
found between the customer's question and the description of this conversational flow. ${setId}`}
              />
            </Colxx>

            {setId !== undefined && (
              <Colxx sm={12} className="mb-3">
                <Card className="bg-light">
                  <CardBody>
                    <div className="assistant-id-row">
                      <span>{setId}</span>
                      <i
                        className="iconsminds-file-copy cursor-pointer"
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          if (navigator.clipboard) {
                            navigator.clipboard.writeText(setId);
                            NotificationManager.success("Copied to clipboard");
                          }
                        }}
                      />
                    </div>
                  </CardBody>
                </Card>
              </Colxx>
            )}
          </>
        )}
        <Colxx xxs="12" className="mb-3">
          <div className='assistant-id-row'>
            <Label><strong>Title:</strong></Label>

            {!isEditingTitle ? (
              <div className="d-flex align-items-center">
                <p className="mb-0 mr-2">
                  {buttonTextInput || "Untitled"}
                </p>

                <FontAwesomeIcon
                  icon={faEdit}
                  style={{ cursor: "pointer", color: "grey" }}
                  onClick={() => setIsEditingTitle(true)}
                />
              </div>
            ) : (
              <Input
                className="input_sty"
                type="text"
                value={buttonTextInput}
                onChange={handleCaptionChange}
                onBlur={() => setIsEditingTitle(false)}
                autoFocus
              />
            )}
          </div>
        </Colxx>
        {seriesType === 'DynamicConversationFlow' && setId !== undefined && (
          <>
            {/* Assistant Id Row */}
            <Colxx xxs="12" className="mb-3">
              <div className="assistant-id-row">
                <strong>Conversation Flow Id:</strong>
                <span className="ml-2">{openAiAssistantId}</span>
                <i
                  className="iconsminds-file-copy cursor-pointer ml-2"
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    if (navigator.clipboard) {
                      navigator.clipboard.writeText(openAiAssistantId);
                      NotificationManager.success("Copied to clipboard");
                    }
                  }}
                />
              </div>
            </Colxx>

            {/* Visibility Checkbox Row */}
            {/* <Colxx xxs="12" className="mb-3">
              <CustomInput
                type="checkbox"
                id="groupVisible"
                checked={seriesIsGroupVisible}
                onChange={handleCheckChange}
                label="Make this Conversation Flow visible across the group"
              />
            </Colxx> */}

            {/* Change Log Row */}
            <Colxx xxs="12" className="mb-3">
              <button
                type="button"
                className="change-log-link"
                onClick={handleToggleLogs}
              >
                Change Log
              </button>
            </Colxx>
          </>
        )}
      </Row>
      <Row>
        <Colxx xxs="12">
          <div style={{ marginTop: ' 5px', marginBottom: '5px' }}>
            {/* {setId !== undefined &&
              seriesType === 'DynamicConversationFlow' && (
                <Button
                  color="primary"
                  className="add-button"
                  onClick={handlePublish}
                  outline
                >
                  Publish
                </Button>
              )} */}

            <Button
              color="light"
              className="add-button float-right ml-2"
              size="xs"
              onClick={handleCancel}
            >
              Cancel
            </Button>
            <Button
              color="secondary"
              className="add-button float-right"
              size="xs"
              onClick={handleSave}
            >
              {seriesType === 'ConversationFlow' ? 'Save' : 'Save'}
            </Button>
            <b> </b>
          </div>
        </Colxx>
      </Row>
      {JsonUploaderButton()}
      {
        showLogs && (
          <Logs
            visible={showLogs}
            label={'Dynamic Conversation Flow'}
            toggle={handleToggleLogs}
            id={setId}
          ></Logs>
        )
      }
      <Modal isOpen={visible} toggle={toggle} modalClassName="dynamic-flow-modal" style={{ maxWidth: '600px' }}>
        <ModalHeader toggle={toggle}>Question Set Logs</ModalHeader>
        <ModalBody>
          <Row className="logs" style={{ height: 'auto', maxHeight: '480px' }}>
            {actions !== undefined &&
              actions !== null &&
              actions.length > 0 &&
              actions.map((m) => (
                <Colxx xxs="12">
                  <Card
                    className="d-flex mb-3"
                    key={`faqItem`}
                    style={{ borderRadius: '25px' }}
                  >
                    <CardBody>
                      <Row className="mb-3">
                        <Colxx xxs="12" className="mb-2">
                          {m.action}
                        </Colxx>
                      </Row>
                    </CardBody>
                  </Card>
                </Colxx>
              ))}
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Back
          </Button>
        </ModalFooter>
      </Modal>

      {/* ── API Definition Modal ── */}
      <Modal
        isOpen={editJson}
        toggle={toggleJson}
        modalClassName="right-side-modal-api"
      >
        <ModalHeader toggle={toggleJson}>
          <h6>API Definition</h6>
          <p className="mt-1">
            Define the API specifications and invoke it through the
            instructions.
            <b>
              <a
                href="https://help.myma.ai/en/articles/9768124-conversation-flows"
                style={{ textDecoration: 'underline' }}
                target="_blank"
              >
                View Examples
              </a>
            </b>
            .
          </p>
        </ModalHeader>
        <ModalBody>
          <div className="definition-layout">
            <div className="json-section">
              <Label>API JSON Definition</Label>
              <textarea
                className="json-textarea"
                value={currentJson?.text || ''}
                onChange={(e) => {
                  const value = e.target.value;
                  setCurrentJson({ ...currentJson, text: value });
                  handleInvokeApiFlow(value, currentJson?.id);
                }}
                onBlur={() => {
                  try {
                    const formatted = JSON.stringify(
                      JSON.parse(currentJson?.text),
                      null,
                      2
                    );
                    setCurrentJson({ ...currentJson, text: formatted });
                    handleInvokeApiFlow(formatted, currentJson?.id);
                  } catch { }
                }}
              />
            </div>
            <div className="instructions-section">
              <Label>Instructions</Label>
              <Input
                className='input_sty'
                type="textarea"
                placeholder="Instructions for this API"
                value={flowInvokeApi.items?.[currentJson?.id]?.instructions || ''}
                onChange={(e) => {
                  const updated = [...flowInvokeApi.items];
                  updated[currentJson.id] = {
                    ...updated[currentJson.id],
                    instructions: e.target.value
                  };
                  setFlowInvokeApi({
                    ...flowInvokeApi,
                    items: updated
                  });
                }}
              />
            </div>
          </div>
        </ModalBody>
        <ModalFooter className="right-modal-footer">
          <Button color="secondary" className="add-button" onClick={toggleJson}>
            Done
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        isOpen={isbrowseApi}
        toggle={() => setIsbrowseApi(false)}
        modalClassName="right-side-modal"
      >
        <ModalBody>
          <Row className="logs">
            <Colxx md="12">
              {templateApiList &&
                templateApiList.length > 0 &&
                templateApiList.map((k, i) => (
                  <Row className="mb-3">
                    <Colxx md={8}>
                      <h5>{k.apiName}</h5>
                      <span>
                        <i>{k.applicability}</i>
                      </span>
                      <br />
                      <span>{k.description}</span>
                      {browseApiId}
                    </Colxx>
                    <Colxx md={4}>
                      <CustomInput
                        key={k.id}
                        type="radio"
                        id={i}
                        value={k.id}
                        checked={k.id == browseApiId ? true : false}
                        onChange={(e) => checkedFlow(e)}
                      />
                    </Colxx>
                  </Row>
                ))}
            </Colxx>
          </Row>
        </ModalBody>
        <ModalFooter className="right-modal-footer">
          <Button color="secondary" onClick={() => setIsbrowseApi(false)}>
            Cancel
          </Button>
          <Button color="primary" onClick={() => AddBrowseAPI()}>
            + Add Pre-Built Block
          </Button>
        </ModalFooter>
      </Modal>

      <Validation
        open={open}
        messages={msg}
        toggle={() => {
          setOpen(!open);
        }}
      ></Validation>
    </div >
  );
}

const mapStateToProps = ({ settings, usersListApp }) => {
  const { propertyId, locale, userName } = settings;
  const { isSuperAdmin } = usersListApp;
  return {
    propertyId,
    locale,
    userName,
    isSuperAdmin
  };
};

export default injectIntl(connect(mapStateToProps)(QuestionSetForm));
